import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Link} from 'react-router-dom';

function ListItem({mandate}) {
  return (
    <tr>
      <td>
        <Link to={`/organisation/broadcast-mandates/${mandate.id}`}>{I18n.t(`mandate.platform.${mandate.platform}`)}</Link>
      </td>
      <td>{I18n.l(mandate.creationDate, {dateFormat: 'datetime.shortDate'})}</td>
    </tr>
  );
}

ListItem.propTypes = {
  mandate: PropTypes.object.isRequired
};

export default ListItem;
